import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=8b1317b8&scoped=true&"
import script from "./PersonalInformation.vue?vue&type=script&lang=ts&"
export * from "./PersonalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInformation.vue?vue&type=style&index=0&id=8b1317b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1317b8",
  null
  
)

export default component.exports